import { doAction, doResponseAction } from ".";

const GET_VENDOR_SERVICE_LIST = 'GET_VENDOR_SERVICE_LIST';
const GET_VENDOR_SERVICE_LIST_SUCCESS = 'GET_VENDOR_SERVICE_LIST_SUCCESS';
const GET_VENDOR_SERVICE_LIST_FAILURE = 'GET_VENDOR_SERVICE_LIST_FAILURE';

const CREATE_VENDOR_SERVICE = 'CREATE_VENDOR_SERVICE';
const CREATE_VENDOR_SERVICE_SUCCESS = 'CREATE_VENDOR_SERVICE_SUCCESS';
const CREATE_VENDOR_SERVICE_FAILURE = 'CREATE_VENDOR_SERVICE_FAILURE';

const UPDATE_VENDOR_SERVICE = ' UPDATE_VENDOR_SERVICE';
const UPDATE_VENDOR_SERVICE_SUCCESS = ' UPDATE_VENDOR_SERVICE_SUCCESS';
const UPDATE_VENDOR_SERVICE_FAILURE = ' UPDATE_VENDOR_SERVICE_FAILURE';

const DELETE_VENDOR_SERVICE = 'DELETE_VENDOR_SERVICE';
const DELETE_VENDOR_SERVICE_SUCCESS = 'DELETE_VENDOR_SERVICE_SUCCESS';
const DELETE_VENDOR_SERVICE_FAILURE = 'DELETE_VENDOR_SERVICE_FAILURE';

const VENDOR_SERVICE_DETAIL = 'VENDOR_SERVICE_DETAIL';
const VENDOR_SERVICE_DETAIL_SUCCESS = 'VENDOR_SERVICE_DETAIL_SUCCESS';
const VENDOR_SERVICE_DETAIL_FAILURE = 'VENDOR_SERVICE_DETAIL_FAILURE';

const GET_VENDOR_ROOM_SERVICE_LIST = 'GET_VENDOR_ROOM_SERVICE_LIST';
const GET_VENDOR_ROOM_SERVICE_LIST_SUCCESS = 'GET_VENDOR_ROOM_SERVICE_LIST_SUCCESS';
const GET_VENDOR_ROOM_SERVICE_LIST_FAILURE = 'GET_VENDOR_ROOM_SERVICE_LIST_FAILURE';

const CREATE_VENDOR_ROOM_SERVICE = 'CREATE_VENDOR_ROOM_SERVICE';
const CREATE_VENDOR_ROOM_SERVICE_SUCCESS = 'CREATE_VENDOR_ROOM_SERVICE_SUCCESS';
const CREATE_VENDOR_ROOM_SERVICE_FAILURE = 'CREATE_VENDOR_ROOM_SERVICE_FAILURE';

const UPDATE_VENDOR_ROOM_SERVICE = 'UPDATE_VENDOR_ROOM_SERVICE';
const UPDATE_VENDOR_ROOM_SERVICE_SUCCESS = 'UPDATE_VENDOR_ROOM_SERVICE_SUCCESS';
const UPDATE_VENDOR_ROOM_SERVICE_FAILURE = 'UPDATE_VENDOR_ROOM_SERVICE_FAILURE';

const VENDOR_ROOM_SERVICE_DETAIL = 'VENDOR_ROOM_SERVICE_DETAIL';
const VENDOR_ROOM_SERVICE_DETAIL_SUCCESS = 'VENDOR_ROOM_SERVICE_DETAIL_SUCCESS';
const VENDOR_ROOM_SERVICE_DETAIL_FAILURE = 'VENDOR_ROOM_SERVICE_DETAIL_FAILURE';
const GET_VENDOR_SRM_IP_AGENT_LIST = 'GET_VENDOR_SRM_IP_AGENT_LIST';
const GET_VENDOR_SRM_IP_AGENT_LIST_SUCCESS = 'GET_VENDOR_SRM_IP_AGENT_LIST_SUCCESS';
const GET_VENDOR_SRM_IP_AGENT_LIST_FAILURE = 'GET_VENDOR_SRM_IP_AGENT_LIST_FAILURE';

const GET_VENDOR_WARD_LIST = 'GET_VENDOR_WARD_LIST';
const GET_VENDOR_WARD_LIST_SUCCESS = 'GET_VENDOR_WARD_LIST_SUCCESS';
const GET_VENDOR_WARD_LIST_FAILURE = 'GET_VENDOR_WARD_LIST_FAILURE';

const CREATE_VENDOR_WARD = 'CREATE_VENDOR_WARD';
const CREATE_VENDOR_WARD_SUCCESS = 'CREATE_VENDOR_WARD_SUCCESS';
const CREATE_VENDOR_WARD_FAILURE = 'CREATE_VENDOR_WARD_FAILURE';

const UPDATE_VENDOR_WARD = 'UPDATE_VENDOR_WARD';
const UPDATE_VENDOR_WARD_SUCCESS = 'UPDATE_VENDOR_WARD_SUCCESS';
const UPDATE_VENDOR_WARD_FAILURE = 'UPDATE_VENDOR_WARD_FAILURE';

const VENDOR_WARD_DETAIL = 'VENDOR_WARD_DETAIL';
const VENDOR_WARD_DETAIL_SUCCESS = 'VENDOR_WARD_DETAIL_SUCCESS';
const VENDOR_WARD_DETAIL_FAILURE = 'VENDOR_WARD_DETAIL_FAILURE';

const GET_VENDOR_HIERARCHY_TREE = 'GET_VENDOR_HIERARCHY_TREE';
const GET_VENDOR_HIERARCHY_TREE_SUCCESS = 'GET_VENDOR_HIERARCHY_TREE_SUCCESS';
const GET_VENDOR_HIERARCHY_TREE_FAILURE = 'GET_VENDOR_HIERARCHY_TREE_FAILURE';

export {
    GET_VENDOR_SERVICE_LIST,
    GET_VENDOR_SERVICE_LIST_SUCCESS,
    GET_VENDOR_SERVICE_LIST_FAILURE,

    CREATE_VENDOR_SERVICE,
    CREATE_VENDOR_SERVICE_SUCCESS,
    CREATE_VENDOR_SERVICE_FAILURE,

    UPDATE_VENDOR_SERVICE,
    UPDATE_VENDOR_SERVICE_SUCCESS,
    UPDATE_VENDOR_SERVICE_FAILURE,

    DELETE_VENDOR_SERVICE,
    DELETE_VENDOR_SERVICE_SUCCESS,
    DELETE_VENDOR_SERVICE_FAILURE,

    VENDOR_SERVICE_DETAIL,
    VENDOR_SERVICE_DETAIL_SUCCESS,
    VENDOR_SERVICE_DETAIL_FAILURE,

    GET_VENDOR_ROOM_SERVICE_LIST,
    GET_VENDOR_ROOM_SERVICE_LIST_SUCCESS,
    GET_VENDOR_ROOM_SERVICE_LIST_FAILURE,

    CREATE_VENDOR_ROOM_SERVICE,
    CREATE_VENDOR_ROOM_SERVICE_SUCCESS,
    CREATE_VENDOR_ROOM_SERVICE_FAILURE,

    UPDATE_VENDOR_ROOM_SERVICE,
    UPDATE_VENDOR_ROOM_SERVICE_SUCCESS,
    UPDATE_VENDOR_ROOM_SERVICE_FAILURE,

    VENDOR_ROOM_SERVICE_DETAIL,
    VENDOR_ROOM_SERVICE_DETAIL_SUCCESS,
    VENDOR_ROOM_SERVICE_DETAIL_FAILURE,

    GET_VENDOR_SRM_IP_AGENT_LIST,
    GET_VENDOR_SRM_IP_AGENT_LIST_SUCCESS,
    GET_VENDOR_SRM_IP_AGENT_LIST_FAILURE,

    GET_VENDOR_WARD_LIST,
    GET_VENDOR_WARD_LIST_SUCCESS,
    GET_VENDOR_WARD_LIST_FAILURE,

    CREATE_VENDOR_WARD,
    CREATE_VENDOR_WARD_SUCCESS,
    CREATE_VENDOR_WARD_FAILURE,

    UPDATE_VENDOR_WARD,
    UPDATE_VENDOR_WARD_SUCCESS,
    UPDATE_VENDOR_WARD_FAILURE,

    VENDOR_WARD_DETAIL,
    VENDOR_WARD_DETAIL_SUCCESS,
    VENDOR_WARD_DETAIL_FAILURE,

    GET_VENDOR_HIERARCHY_TREE,
    GET_VENDOR_HIERARCHY_TREE_SUCCESS,
    GET_VENDOR_HIERARCHY_TREE_FAILURE,
}

export const getVendorRoomService = store => store['VENDOR_ROOM_SERVICES']


export const getVendorServiceList = (params, callback) => doAction(GET_VENDOR_SERVICE_LIST, params, callback);
export const getVendorServiceListSuccess = data => doResponseAction(GET_VENDOR_SERVICE_LIST_SUCCESS, data);
export const getVendorServiceListFailure = data => doResponseAction(GET_VENDOR_SERVICE_LIST_FAILURE, data);

export const createVendorService = (params, callback) => doAction(CREATE_VENDOR_SERVICE, params, callback);
export const createVendorServiceSuccess = data => doResponseAction(CREATE_VENDOR_SERVICE_SUCCESS, data);
export const createVendorServiceFailure = data => doResponseAction(CREATE_VENDOR_SERVICE_FAILURE, data);

export const updateVendorService = (params, callback) => doAction(UPDATE_VENDOR_SERVICE, params, callback);
export const updateVendorServiceSuccess = data => doResponseAction(UPDATE_VENDOR_SERVICE_SUCCESS, data);
export const updateVendorServiceFailure = data => doResponseAction(UPDATE_VENDOR_SERVICE_FAILURE, data);

export const deleteVendorService = (params, callback) => doAction(DELETE_VENDOR_SERVICE, params, callback);
export const deleteVendorServiceSuccess = data => doResponseAction(DELETE_VENDOR_SERVICE_SUCCESS, data);
export const deleteVendorServiceFailure = data => doResponseAction(DELETE_VENDOR_SERVICE_FAILURE, data);

export const getVendorServiceDetail = (params, callback) => doAction(VENDOR_SERVICE_DETAIL, params, callback);
export const getVendorServiceDetailSuccess = data => doResponseAction(VENDOR_SERVICE_DETAIL_SUCCESS, data);
export const getVendorServiceDetailFailure = data => doResponseAction(VENDOR_SERVICE_DETAIL_FAILURE, data);

export const getVendorRoomServiceList = (params, callback) => doAction(GET_VENDOR_ROOM_SERVICE_LIST, params, callback);
export const getVendorRoomServiceListSuccess = data => doResponseAction(GET_VENDOR_ROOM_SERVICE_LIST_SUCCESS, data);
export const getVendorRoomServiceListFailure = data => doResponseAction(GET_VENDOR_ROOM_SERVICE_LIST_FAILURE, data);

export const createVendorRoomService = (params, callback) => doAction(CREATE_VENDOR_ROOM_SERVICE, params, callback);
export const createVendorRoomServiceSuccess = data => doResponseAction(CREATE_VENDOR_ROOM_SERVICE_SUCCESS, data);
export const createVendorRoomServiceFailure = data => doResponseAction(CREATE_VENDOR_ROOM_SERVICE_FAILURE, data);

export const updateVendorRoomService = (params, callback) => doAction(UPDATE_VENDOR_ROOM_SERVICE, params, callback);
export const updateVendorRoomServiceSuccess = data => doResponseAction(UPDATE_VENDOR_ROOM_SERVICE_SUCCESS, data);
export const updateVendorRoomServiceFailure = data => doResponseAction(UPDATE_VENDOR_ROOM_SERVICE_FAILURE, data);

export const getVendorRoomServiceDetail = (params, callback) => doAction(VENDOR_ROOM_SERVICE_DETAIL, params, callback);
export const getVendorRoomServiceDetailSuccess = data => doResponseAction(VENDOR_ROOM_SERVICE_DETAIL_SUCCESS, data);
export const getVendorRoomServiceDetailFailure = data => doResponseAction(VENDOR_ROOM_SERVICE_DETAIL_FAILURE, data);

export const getVendorSrmIpAgentList = (params, callback) => doAction(GET_VENDOR_SRM_IP_AGENT_LIST, params, callback);
export const getVendorSrmIpAgentListSuccess = data => doResponseAction(GET_VENDOR_SRM_IP_AGENT_LIST_SUCCESS, data);
export const getVendorSrmIpAgentListFailure = data => doResponseAction(GET_VENDOR_SRM_IP_AGENT_LIST_FAILURE, data);

export const getVendorWardList = (params, callback) => doAction(GET_VENDOR_WARD_LIST, params, callback);
export const getVendorWardListSuccess = data => doResponseAction(GET_VENDOR_WARD_LIST_SUCCESS, data);
export const getVendorWardListFailure = data => doResponseAction(GET_VENDOR_WARD_LIST_FAILURE, data);

export const createVendorWard = (params, callback) => doAction(CREATE_VENDOR_WARD, params, callback);
export const createVendorWardSuccess = data => doResponseAction(CREATE_VENDOR_WARD_SUCCESS, data);
export const createVendorWardFailure = data => doResponseAction(CREATE_VENDOR_WARD_FAILURE, data);

export const updateVendorWard = (params, callback) => doAction(UPDATE_VENDOR_WARD, params, callback);
export const updateVendorWardSuccess = data => doResponseAction(UPDATE_VENDOR_WARD_SUCCESS, data);
export const updateVendorWardFailure = data => doResponseAction(UPDATE_VENDOR_WARD_FAILURE, data);

export const getVendorWardDetail = (params, callback) => doAction(VENDOR_WARD_DETAIL, params, callback);
export const getVendorWardDetailSuccess = data => doResponseAction(VENDOR_WARD_DETAIL_SUCCESS, data);
export const getVendorWardDetailFailure = data => doResponseAction(VENDOR_WARD_DETAIL_FAILURE, data);

export const getVendorHierarchyTree = (params, callback) => doAction(GET_VENDOR_HIERARCHY_TREE, params, callback);
export const getVendorHierarchyTreeSuccess = data => doResponseAction(GET_VENDOR_HIERARCHY_TREE_SUCCESS, data);
export const getVendorHierarchyTreeFailure = data => doResponseAction(GET_VENDOR_HIERARCHY_TREE_FAILURE, data);